/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Excl_VatInputs */



/**
* | output |
* | --- |
* | "excl. VAT" |
*
* @param {Billing_Excl_VatInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const billing_excl_vat = /** @type {((inputs?: Billing_Excl_VatInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Excl_VatInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("zzgl. MwSt.")
	return /** @type {LocalizedString} */ ("excl. VAT")
});